import React from 'react';

interface Props {
  style?: object;
  color?: string;
}

export default function IconJCB({ style, color = '#003A1B' }: Props) {
  return (
    <svg style={style} fill="none" height="9" viewBox="0 0 11 9" width="11" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="m3.58975 7.77568-.00001.00001-3.225608-3.22561c-.3905245-.39052-.3905255-1.02369-.000001-1.41421.390525-.39053 1.023689-.39053 1.414209 0l2.12132 2.12132 4.72166-4.721658c.39052-.390525 1.02369-.390524 1.41418 0 .3906.390524.3906 1.023688 0 1.414218l-6.13583 6.13586z"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
}
